import React from 'react'

import Styled from './ThemeIcon.styled'

const ThemeIcon = ({ className, size, isDark, backgroundColor }) => {
  return (
    <Styled className={className} containerSize={size}>
      <Styled.circle isDark={isDark} />

      <Styled.cover isDark={isDark} backgroundColor={backgroundColor} />

      <Styled.ray1 isDark={isDark} />
      <Styled.ray2 isDark={isDark} />
      <Styled.ray3 isDark={isDark} />
      <Styled.ray4 isDark={isDark} />
      <Styled.ray5 isDark={isDark} />
      <Styled.ray6 isDark={isDark} />
    </Styled>
  )
}

ThemeIcon.defaultProps = {
  size: 48,
}

export default ThemeIcon
